
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Innovacrystahireinmumbai() {



    const cardData =
    {
        keyword: 'Innova Crysta Hire in Mumbai',
        heading: 'S9 Travels: Innova Crysta Hire in Mumbai',
        headingDescription: 'S9 Travels offers Innova Crysta Hire in Mumbai, providing a spacious, comfortable, and premium travel experience for family trips, corporate travel, airport transfers, and outstation journeys. Our well-maintained Innova Crysta comes with luxury interiors, ample legroom, and professional drivers to ensure a smooth and hassle-free ride. Enjoy affordable pricing, on-time service, and 24/7 availability for your travel needs. Book your Innova Crysta in Mumbai with S9 Travels for a comfortable and reliable journey!',


        top: 'Top Places to Visit in Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Gateway of India",
      "description": "One of Mumbai’s most iconic landmarks, the Gateway of India was built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, it is a popular tourist attraction where visitors can enjoy ferry rides to Elephanta Caves. The area around the Gateway is bustling with street vendors, photographers, and local performers, making it a lively spot for tourists."
    },
    {
      "title": "Marine Drive",
      "description": "Also known as the 'Queen’s Necklace' due to its beautiful curve that lights up at night, Marine Drive is a 3.6 km-long boulevard along the Arabian Sea. It is a favorite spot for Mumbaikars and tourists alike, offering mesmerizing sunset views, a cool sea breeze, and a serene atmosphere for leisurely strolls. Nearby attractions include Girgaon Chowpatty, famous for Mumbai’s street food like pav bhaji and bhel puri."
    },
    {
      "title": "Elephanta Caves",
      "description": "Located on Elephanta Island, these UNESCO-listed rock-cut caves date back to the 5th-7th century. They feature intricate sculptures of Lord Shiva, including the famous three-faced Maheshmurti. Visitors can reach the island via ferry from the Gateway of India, enjoying scenic views of Mumbai’s coastline along the way."
    },
    {
      "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
      "description": "A UNESCO World Heritage Site, this grand railway station is a masterpiece of Victorian Gothic architecture. Built in 1887, it blends Indian and British styles, featuring domes, turrets, stained glass windows, and elaborate carvings. It remains one of the busiest railway stations in India and is a must-visit for history and architecture enthusiasts."
    },
    {
      "title": "Siddhivinayak Temple",
      "description": "One of Mumbai’s most revered temples, Siddhivinayak Temple is dedicated to Lord Ganesha. Built in 1801, the temple attracts thousands of devotees, including Bollywood celebrities and politicians, who come to seek blessings. The temple's architecture features a gold-plated inner sanctum and intricately carved wooden doors."
    },
    {
      "title": "Haji Ali Dargah",
      "description": "Situated on a small islet off the coast of Worli, Haji Ali Dargah is a stunning Indo-Islamic shrine dedicated to the Sufi saint Pir Haji Ali Shah Bukhari. The structure is accessible via a narrow causeway during low tide, offering breathtaking views of the Arabian Sea. It is a place of spirituality, visited by people of all religions seeking blessings."
    },
    {
      "title": "Juhu Beach",
      "description": "Famous for its lively atmosphere and street food stalls, Juhu Beach is a favorite among locals and tourists. It is a great place to relax, enjoy Mumbai’s famous chaats, and watch stunning sunsets. Bollywood celebrities often visit this area, as many reside nearby."
    },
    {
      "title": "Colaba Causeway",
      "description": "A paradise for street shopping lovers, Colaba Causeway is lined with stalls selling clothes, accessories, souvenirs, and antiques. It is also home to the iconic Café Mondegar and Leopold Café, making it a great spot to enjoy Mumbai’s vibrant culture."
    },
    {
      "title": "Bandra-Worli Sea Link",
      "description": "This architectural marvel connects South Mumbai with the western suburbs. The cable-stayed bridge offers stunning views of the Mumbai skyline, especially at night when it is beautifully illuminated. A drive across the Sea Link is a must-experience for visitors to the city."
    },
    {
      "title": "Sanjay Gandhi National Park & Kanheri Caves",
      "description": "One of the few national parks within a city, Sanjay Gandhi National Park offers lush greenery, nature trails, and wildlife sightings. Within the park lie the Kanheri Caves, ancient Buddhist rock-cut caves dating back to the 1st century BCE. The park is a perfect retreat for nature lovers and history enthusiasts."
    }
],

"services": [
  {
    "name": "Innova Crysta Hire in Mumbai",
    "description": "S9 Travels offers Innova Crysta hire services in Mumbai, providing you with a premium and comfortable vehicle for all your travel needs. Whether you're traveling with family, friends, or on business, the Innova Crysta ensures a smooth and enjoyable journey."
  },
  {
    "name": "Book Innova Crysta in Mumbai",
    "description": "Booking an Innova Crysta in Mumbai is simple with S9 Travels. Whether you're going on a family trip, attending a corporate event, or need a vehicle for a special occasion, we offer convenient booking options to make your journey seamless and comfortable."
  },
  {
    "name": "Affordable Innova Crysta Rental in Mumbai",
    "description": "S9 Travels offers affordable Innova Crysta rental in Mumbai, combining competitive pricing with premium quality. We provide budget-friendly rental options without compromising comfort, allowing you to enjoy a luxurious ride at a reasonable price."
  },
  {
    "name": "Luxury Innova Crysta Rental in Mumbai",
    "description": "For those seeking luxury and comfort, S9 Travels offers luxury Innova Crysta rentals in Mumbai. Equipped with all modern amenities, our luxury vehicles ensure a smooth, comfortable, and stylish ride for any occasion, whether for business or leisure."
  },
  {
    "name": "Innova Crysta for Group Travel in Mumbai",
    "description": "S9 Travels provides Innova Crysta for group travel in Mumbai, ensuring spacious and comfortable travel for families, friends, or corporate groups. Our vehicles are ideal for large groups, offering ample space for both passengers and luggage, making your group trip enjoyable and stress-free."
  },
  {
    "name": "Private Hire of Innova Crysta in Mumbai",
    "description": "For a personalized travel experience, choose private hire of the Innova Crysta in Mumbai with S9 Travels. Enjoy exclusive services, a dedicated chauffeur, and a comfortable ride tailored to your schedule and travel preferences."
  },
  {
    "name": "Mumbai to Outstation Travel by Innova Crysta",
    "description": "Travel in comfort with S9 Travels' Innova Crysta for outstation trips from Mumbai. Whether it's a short getaway or a long-distance journey, our well-maintained vehicles and experienced chauffeurs ensure a smooth and comfortable ride to your destination."
  },
  {
    "name": "Comfortable Innova Crysta Travel in Mumbai",
    "description": "Experience comfortable travel within Mumbai with the Innova Crysta. Whether you're heading to a business meeting, a family event, or just exploring the city, S9 Travels provides a reliable and comfortable ride that makes every trip smooth and enjoyable."
  },
  {
    "name": "Innova Crysta for Special Occasions in Mumbai",
    "description": "S9 Travels offers Innova Crysta rentals for special occasions in Mumbai, including weddings, corporate events, parties, and more. With its luxurious features and spacious interior, the Innova Crysta makes every occasion more memorable and comfortable."
  }
],

"tableData": [
  ["Innova Crysta Hire in Mumbai", "Book Innova Crysta in Mumbai"],
  ["Affordable Innova Crysta Rental in Mumbai", "Luxury Innova Crysta Rental in Mumbai"],
  ["Innova Crysta for Group Travel in Mumbai", "Private Hire of Innova Crysta in Mumbai"],
  ["Mumbai to Outstation Travel by Innova Crysta", "Comfortable Innova Crysta Travel in Mumbai"],
  ["Innova Crysta for Special Occasions in Mumbai", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Premium Comfort and Spacious Ride",
    "WhyChoosedescription": "S9 Travels offers the premium Innova Crysta for hire in Mumbai, perfect for both short and long-distance trips. The spacious interiors, plush seating, and advanced features of the Innova Crysta ensure that your journey is comfortable and enjoyable, whether you're traveling for business, leisure, or a special event."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand the importance of punctuality. Our Innova Crysta hire service in Mumbai guarantees timely pick-ups and drop-offs, so you can relax and enjoy your ride without worrying about delays. Whether it's a corporate event, family trip, or airport transfer, we ensure reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced and professional drivers are skilled in navigating Mumbai's roads. They ensure a smooth and safe ride, prioritizing comfort and efficiency, and are dedicated to providing excellent customer service during your journey in the Innova Crysta."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Innova Crysta hire in Mumbai, with no hidden charges. We provide transparent pricing, and you’ll receive a clear breakdown of the cost at the time of booking, making it easier to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Every Ride",
    "WhyChoosedescription": "Your safety is our priority. The Innova Crysta is equipped with modern safety features such as airbags, GPS tracking, and seat belts, ensuring a safe and comfortable journey for you and your passengers throughout your trip in Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, providing flexible scheduling for your Innova Crysta hire in Mumbai. Whether you need a ride for an early morning meeting, a late-night airport transfer, or a weekend getaway, we are available to meet your needs at any time."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Journey",
    "WhyChoosedescription": "We understand that every trip is different. Whether you need multiple stops, special arrangements, or a customized route, we offer flexible and customizable itineraries to make your journey in the Innova Crysta more convenient and enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Innova Crysta with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance, ensuring a seamless and quick booking experience."
  }
]













    }

    const faqData = [
        [
          {
            question: 'How can I hire an Innova Crysta in Mumbai?',
            answer: 'Hiring an Innova Crysta in Mumbai is simple! You can book your vehicle through our website, mobile app, or by contacting our customer service team for personalized assistance. We’ll ensure a smooth booking process for your needs.',
          },
          {
            question: 'What is the seating capacity of the Innova Crysta?',
            answer: 'The Innova Crysta can comfortably accommodate up to 7 passengers, including the driver. It is perfect for family trips, group travel, or business travel with ample space for luggage.',
          },
          {
            question: 'Is the Innova Crysta available for both local and outstation hire in Mumbai?',
            answer: 'Yes, the Innova Crysta is available for both local and outstation hire in Mumbai. Whether you need it for a city tour, airport transfer, or an outstation trip, we can provide a vehicle that suits your travel requirements.',
          },
          {
            question: 'Are the Innova Crysta vehicles well-maintained?',
            answer: 'Yes, all our Innova Crysta vehicles are regularly maintained and serviced to ensure they are in top condition. You can be assured of a smooth and safe ride with our well-maintained fleet.',
          },
          {
            question: 'Can I hire the Innova Crysta for a full day or multiple days?',
            answer: 'Yes, you can hire the Innova Crysta for a full day, multiple days, or based on your specific travel duration. We offer flexible rental options to suit your schedule and needs.',
          },
          {
            question: 'Is there a driver included with the Innova Crysta hire in Mumbai?',
            answer: 'Yes, every Innova Crysta rental in Mumbai comes with an experienced and professional driver. Our drivers are well-versed with city routes, ensuring you a safe and comfortable journey.',
          },
          {
            question: 'How much does it cost to hire an Innova Crysta in Mumbai?',
            answer: 'The cost of hiring an Innova Crysta in Mumbai depends on factors such as the duration of the hire, the type of trip (local or outstation), and the distance. Contact us for a customized quote based on your requirements.',
          },
          {
            question: 'Can I request additional services like meals or sightseeing during the hire?',
            answer: 'Yes, we can arrange additional services like meals, sightseeing, and more during your Innova Crysta hire. Let us know your preferences, and we’ll ensure a comfortable and customized experience.',
          },
          {
            question: 'Why should I hire an Innova Crysta from S9 Travels in Mumbai?',
            answer: 'S9 Travels offers well-maintained and comfortable Innova Crysta vehicles with professional drivers. Whether you’re planning a short trip within Mumbai or an extended journey outside the city, we guarantee a safe, comfortable, and memorable experience.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I hired an Innova Crysta from S9 Travels for a family trip in Mumbai, and it was an excellent experience. The vehicle was clean, spacious, and well-maintained, and the driver was very polite and professional. I highly recommend S9 Travels for anyone looking to hire a comfortable vehicle in Mumbai.”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“We hired an Innova Crysta from S9 Travels for an outstation trip from Mumbai, and it was a fantastic experience. The vehicle was comfortable, and the driver was very knowledgeable about the route. It made our journey smooth and enjoyable. I would definitely recommend their service for anyone needing a reliable vehicle hire in Mumbai.”',
        },
      ];
      
      
      
      
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
      
      


    return (
        <div>
        

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/81.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystahireinmumbai;